import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Input } from '@/components/ui/Input';
import { Button } from '@/components/ui/Button';
import { Mail } from 'lucide-react';

export function EmailSettingsForm() {
  return (
    <Card>
      <CardHeader title="Configuration SMTP" />
      <CardContent>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <Input label="Hote SMTP" placeholder="smtp.example.com" icon={<Mail className="h-4 w-4" />} />
            <Input label="Port" type="number" placeholder="587" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Input label="Utilisateur" placeholder="user@example.com" />
            <Input label="Mot de passe" type="password" placeholder="Mot de passe" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Input label="Email expediteur" placeholder="noreply@innov-paie.fr" />
            <Input label="Nom expediteur" placeholder="Innov' Paie" />
          </div>
          <Button>Sauvegarder</Button>
        </div>
      </CardContent>
    </Card>
  );
}
